import React from "react";
import { useSelector } from "react-redux";

import { boxContainer, Loader, progressbar } from "../../components";

import { Colors } from "../../config";

const StudentsTopPart = () => {
  const { studentsAnalytics, isAnalyticsLoading } = useSelector(
    (state) => state.students
  );

  const data = [
    {
      title: "Active Students",
      value: studentsAnalytics?.activeStudentsPercentage ?? 0,
      color: "#0AC10A",
      trail: "#D9F6D9",
    },
    {
      title: "Pending Students",
      value: studentsAnalytics?.pendingStudentsPercentage ?? 0,
      color: "#FFCD06",
      trail: "#ffefb1",
    },
    {
      title: "Universities - Shortlist",
      value: studentsAnalytics?.shortlistedPercentage ?? 0,
      color: "#15A4D1",
      trail: "#d1f1fb",
    },
    {
      title: "Universities - Applying",
      value: studentsAnalytics?.appliedPercentage ?? 0,
      color: Colors.main,
      trail: "#c5ece7",
    },
  ];

  return (
    <div>
      {isAnalyticsLoading ? (
        <Loader.Circular />
      ) : (
        <div className="grid grid-cols-4 gap-[3.125em]">
          {data?.map((item, index) => (
            <boxContainer.LiteBoxContainer key={index}>
              <progressbar.StudentsProgressBar
                value={item?.value}
                text={item?.title}
                color={item?.color}
                trail={item?.trail}
              />
            </boxContainer.LiteBoxContainer>
          ))}
        </div>
      )}
    </div>
  );
};

export default StudentsTopPart;
